export function lineaMeta(entreno) {
  if (!entreno) return '';
  const metrics = [entreno.clock, entreno.distance, entreno.tss ? `${entreno.tss} TSS` : null]
    .filter(Boolean)
    .join(' · ');
  const detalle = String(entreno.detalle || '').trim();
  return [metrics, detalle].filter(Boolean).join(' · ');
}

export function cabeceraDia(entreno) {
  if (!entreno) return '';
  return [entreno.etiqueta, entreno.sport].filter(Boolean).join(' · ');
}
